import "./status/index.js";

// Merged onto the existing namespace, never replaced: `status/_namespaces.js`
// installs `AddressAvailability.Status` (Views, Models), and module-eval order
// in the bundle can place this file after it — a plain object assignment here
// wiped `Status` and `createStatusBadge` then threw "Cannot read properties of
// undefined (reading 'Views')" when rendering location status badges.
window.AddressAvailability = Object.assign(window.AddressAvailability || {}, {
  // The catalog SparkleConfig carries for the page's locale. Merged under the
  // catalog the server passes to createStatusBadge, so markup cached before
  // that argument existed still renders words rather than keys.
  defaultI18n() {
    return window.SparkleConfig?.translations?.js_components?.address_availability ?? {};
  },

  createStatusBadge(addressId, i18n = {}) {
    const deferred = new jQuery.Deferred();

    jQuery.when().then(() => {
      AddressAvailability.Status.i18n = new Sparkle.I18n(this.defaultI18n()).merge(i18n);
      const model = new Backbone.Model({ addressId });
      const widgetView = new AddressAvailability.Status.Views.Widget({ model });
      return deferred.resolve(widgetView);
    });

    return deferred.promise();
  },
});
